"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styles = __importStar(require("./Header.module.css"));
function Header(props) {
    var children = props.children, classNames = props.classNames;
    return (React.createElement("div", { className: styles.headerWrap + " " + (classNames || "") },
        React.createElement("div", { className: styles.headerTitleWrap }, children)));
}
exports.default = Header;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSGVhZGVyLmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvZm9ybXMvYmVsbHVzL0Vucm9sbG1lbnRBZ3JlZW1lbnQvcGFydHMvU2VjdGlvbjEvSGVhZGVyL0hlYWRlci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsMkNBQThCO0FBQzlCLDBEQUE2QztBQUU3QyxTQUF3QixNQUFNLENBQUMsS0FBSztJQUN6QixJQUFBLHlCQUFRLEVBQUUsNkJBQVUsQ0FBUztJQUVwQyxPQUFPLENBQ0gsNkJBQUssU0FBUyxFQUFLLE1BQU0sQ0FBQyxVQUFVLFVBQUksVUFBVSxJQUFJLEVBQUUsQ0FBRTtRQUN0RCw2QkFBSyxTQUFTLEVBQUUsTUFBTSxDQUFDLGVBQWUsSUFBRyxRQUFRLENBQU8sQ0FDdEQsQ0FDVCxDQUFBO0FBQ0wsQ0FBQztBQVJELHlCQVFDIn0=